import { axios } from '../../utilities/axiosClient'
import { VoucherDetail } from '../../types/Voucher'

/**
 * 店舗詳細を取得する
 */
export const getVoucherShopDetail = (id: number): Promise<VoucherDetail> =>
  axios.get(`/api/voucher/${id}`)
